<template>
  <div>
    <div class="search-input-container" v-if="layout === 'selectClient' || layout === 'offerSelectClient'">
        <v-text-field
          class="search-input"
          background-color="bgDefault"
          height="55px"
          single-line
          flat
          solo
          hide-details
          :placeholder="languageData.labels.search"
          @keyup="filtersClients"
          v-model="searchName"
          :label="languageData.labels.search"
          prepend-inner-icon="mdi-magnify"        
        >
        </v-text-field>
      </div>
    <v-data-table
        loading-text="Loading... Please wait"
        class="users-table"
        :search="searchName"
        :headers="headers"
        :loading="loadingClients"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :items-per-page-options="rowsPerPageItems"
        :footer-props="footerOptions"
        :page.sync="currentPage"
        :hide-default-footer="layout === 'choosePerson'"
        :items="clients"
        mobile-breakpoint="0"
        >
      <template v-slot:item.logo="{ item }">
        <v-avatar :color="item.hexColor" size="40" class="mr-2" style="cursor: pointer" @click="previewClient(item.id)">
          <span class="white--text headline">{{ getFirstLetter(item.name) }}</span>
        </v-avatar>
      </template>
      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>
      <template v-slot:item.client_type="{ item }">
        {{ languageData.clientTypes[item.client_type] }}
      </template>
      <template v-slot:item.actions="{ item }">
        <td class="justify-center">
          <template v-if="layout === 'list'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="previewClient(item.id)"
                    icon>
                  <v-icon color="fontDefault">preview</v-icon>
                </v-btn>
              </template>
              <span>{{ languageData.operation.preview }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="editClient(item.id)"
                    icon>
                  <v-icon color="fontDefault">edit</v-icon>
                </v-btn>
              </template>
              <span>{{ languageData.operation.edit }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click="showDeleteClientModal(item)">
                  <v-icon color="fontDefault">delete</v-icon>
                </v-btn>
              </template>
              <span>{{ languageData.operation.delete }}</span>
            </v-tooltip>
          </template>
          <template v-if="layout === 'selectClient'">
            <template v-if="item.disabled">
              <v-btn :disabled="true"  @click="selectClient(item, clients.selectedId)" color="primary">{{ languageData.selected }}</v-btn>
            </template>
            <template v-else>
              <v-btn :disabled="false"  @click="selectClient(item, clients.selectedId)" color="primary"> {{ languageData.select }} </v-btn>
            </template>
          </template>
          <template v-if="layout === 'choosePerson'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    @click="showClientPersonsModal(item)">
                  <v-icon>mdi-account-group</v-icon>
                </v-btn>
              </template>
              <span>{{ languageData.documents.choosePerson }}</span>
            </v-tooltip>
          </template>
          <template v-if="layout === 'offerSelectClient'">
            <template v-if="item.disabled">
              <v-btn :disabled="true"  @click="selectOfferClient(item, clients.selectedId)" color="primary">{{ languageData.select }}</v-btn>
            </template>
            <template v-else>
              <v-btn :disabled="false"  @click="selectOfferClient(item, clients.selectedId)" color="primary">{{ languageData.select }}</v-btn>
            </template>
          </template>
        </td>
      </template>
    </v-data-table>
    <template v-if="layout === 'list'">
      <ModalInfo @doOperation="deleteClient" :isLoadingBtn="false" :idData="modalDeleteData.idData" :typeInfo="modalDeleteData.typeInfo" :headModal="modalDeleteData.head" :btnDisAgreeText="languageData.modalDelete.btnDisAgreeText" :btnAgreeText="languageData.modalDelete.btnAgreeText" :vis-agree-btn="true" :visDisAgreeBtn="true" @clicked="hideModalDelete" :show-modal="isShowDeleteModal" :text-modal="modalDeleteData.textInfo"></ModalInfo>
      <ModalInfo  :typeInfo="modalDeleteInfoData.typeInfo" :headModal="modalDeleteInfoData.head" :btnAgreeText="languageData.btnAgreeText" @clicked="hideModalDeleteInfo" :show-modal="isShowDeleteModalInfo" :text-modal="modalDeleteInfoData.textInfo"></ModalInfo>
    </template>
    <template v-if="layout === 'choosePerson'">
      <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideClientPersonsModal" :show-modal="showClientPersons">
        <template v-slot:header>
          {{ languageData.documents.choosePerson }}
        </template>
        <template v-slot:body>
          <ClientPersonsList :layout="layout" :clientPersons="clientPersons"></ClientPersonsList>
        </template>
      </ModalInfo>
    </template>
    <ModalInfo :typeInfo="'success'" :headModal="successSaveClientModalData.message" :btnAgreeText="languageData.btnAgreeText" @clicked="hideModalSaveInfo" :show-modal="isShowSaveModalInfo" :text-modal="successSaveClientModalData.textInfo"></ModalInfo>
  </div>
</template>

<script type="text/javascript">
  import {mapActions, mapState} from "vuex";
  import clientTypes from "../../enums/ClientTypeEnum";
  import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
  import eventBus from "../../../../event-bus/eventBus";
  import router from "../../../../../router";
  import ClientPersonsList from "../../../Clients/components/ClientPersonsList/ClientPersonsList";

  export default {
    name: "ClientsTableDynamic",
    props: {
      clients: Array,
      headers: Array,
      layout: String
    },
    components: {
      ModalInfo, ClientPersonsList
    },
    data() {
      return {
        deleteClientModal: false,
        formTitle: "Clients",
        dialog: false,
        textInfoCompanySave: "",
        item: {},
        page:1,
        pageCount:8,
        items: clientTypes,
        modalSaveInfoData: {},
        currentPage: 1,
        indexDelete: 0,
        isShowSaveModalInfo: false,
        disabledBtn: [],
        footerOptions: {},
        loading: true,
        showClientPersons: false,
        clientPersons: null,
        searchName: "",
      }
    },
    computed: {
      ...mapState("getClients", {
        dataReceive: state => state.dataReceive,
        totalItems: state => state.pagination.totalItems,
        rowsPerPageItems: state => state.pagination.rowsPerPage,
        sortBy: state => state.pagination.sortBy,
        loadingClients: state => state.loadingClients
      }),
      ...mapState("deleteClient", {
        isShowDeleteModal: state => state.isShowDeleteModal,
        isLoadingDeleteModal: state => state.isLoadingDeleteModal,
        isShowDeleteModalInfo: state => state.isShowDeleteModalInfo,
        modalDeleteInfoData: state => state.modalDeleteInfoData,
        modalDeleteData: state => state.modalDeleteData
      }),
      ...mapState("saveClientPerson", {
        isSuccessSaveClientModalVisible: state => state.isSuccessSaveClientModalVisible,
        successSaveClientModalData: state => state.successSaveClientModalData
      }),
      ...mapState("getClient", {
        newClient: state => state.dataReceive,
      }),
      
      pagination: {
        set: function(value) {
          eventBus.$emit("searchClients", value);
        },
        get: function() {
          return this.$store.state.getClients.pagination;
        }
      },
    },
    methods: {
      ...mapActions("deleteClient", ["showDeleteModal", 'deleteClientRequest', 'showModalDeleteData', 'hideModalDeleteAction', 'hideModalDeleteInfoAction']),
      ...mapActions("saveClientPerson", ["updateVisibleSuccessSaveClientModal"]),
      ...mapActions("getClients", ["getClients"]),

      filtersClients: function() {
        eventBus.$emit("filterClientsTableDynamic", this.searchName);
      },

      deleteClient(value) {
        this.deleteClientRequest(value, true);
      },
      hideModalDeleteInfo: function() {
        this.hideModalDeleteInfoAction();
      },
      hideModalDelete: function() {
        this.hideModalDeleteAction();
      },
      hideModalSaveInfo: function() {
        this.updateVisibleSuccessSaveClientModal(false);
        this.isShowSaveModalInfo = false
      },
      selectClient: function(item) {
        eventBus.$emit("addClientStep", item);
        eventBus.$emit("addClientSelect", item);
      },
      selectOfferClient: function(item) {
        eventBus.$emit("addClientStep", item);
        eventBus.$emit("addOfferClientSelect", item);
      },
      getFirstLetter(companyName) {
        return companyName.charAt(0);
      },
      showDeleteClientModal: function(item) {
        var modalDeleteData = {};
        modalDeleteData.name = item.name;
        modalDeleteData.id = item.id;
        modalDeleteData.index = this.clients.indexOf(item);
        modalDeleteData.languageData = this.languageData.modalDelete;
        this.showModalDeleteData(modalDeleteData);
      },
      editClient: function(id) {
        router.push({ path: "/clients/edit", query: { id: id }});
      },
      previewClient: function(id) {
        router.push({ path: '/clients/edit', query: { id: id }});
      },
      showClientPersonsModal(item) {
        this.showClientPersons = true;
        this.clientPersons = item.persons;
      },
      hideClientPersonsModal() {
        this.showClientPersons = false;
      }
    },
    watch: {
      newClient(newValue) {
        this.clients.push(newValue);
      }
    },
    mounted() {
      if (this.isSuccessSaveClientModalVisible) {
        this.isShowSaveModalInfo = true;
      }

      eventBus.$on("setDisablePagination", (value) => {
        this.footerOptions["disablePagination"] = value;
      })

      eventBus.$on('enableToSelectClient', (id) => {
        this.clients.find(el => el.id === id).disabled = false;
      })

      if(this.layout === "selectClient") {
        this.footerOptions =  {
          'items-per-page-options': [10, 20],
          'disablePagination': false
        }
      } else if(this.layout === "offerSelectClient") {
        this.footerOptions = {
          'disablePagination': true
        }
      } else {
        this.footerOptions = {
          "items-per-page-option": [20, 50, 100],
          'disablePagination': false
        }
      }
      eventBus.$on("deleteItemSelect", (clientId, isInvoiceGenerated) => {
        if (!isInvoiceGenerated) {
          this.clients.splice(this.modalDeleteData.index, 1);
        }  
      });
    },
    beforeDestroy() {
      eventBus.$off('addClientStep');
      eventBus.$off('addOfferClientSelect');
      eventBus.$off('addClientSelect');
      eventBus.$off('enableToSelectClient');
    }
  }
</script>